module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GaLoSt/tc-custom/9781623954734.jpg?1701477060368",
      "alt": "This image is the cover for the book I Love You!, Xist Children's Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("I Love You!, Xist Children's Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A heartwarming, rhyming picture book, perfect for teaching little ones about love as they learn how to read.")]), _c('br'), _c('br'), _vm._v("“I love you like a skipping stone . . . I love you like a doggy’s bone . . .”"), _c('br'), _c('br'), _vm._v("Celebrating the love between a parent and a child, this rhyming book features a host of animals and the things they love about each other. Perfect for babies, toddlers, preschoolers and as a reminder to the big kids in your life.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Calee M. Lee, Tricia Tharp\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Calee M. Lee loves forest walks, city bakeries and 3-book weekends. She is the author of more that 15 children's books and the reader of at least 15,000. She lives with her husband, 2 children, and cat in Southern California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    www.redjumper.net/bookcreator\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0